import React, { Component } from 'react'

import { bemClasses } from '../../utils/bem'

import { Col } from 'reactstrap'

class Column extends Component {
  ALLOWED_MODIFIERS = []

  componentClassNames = () => {
    return bemClasses('column', this.ALLOWED_MODIFIERS, this.props)
  }

  render = () => {
    return (
      <Col
        xs={this.props.xs}
        sm={this.props.sm}
        md={this.props.md}
        lg={this.props.lg}
        className={this.componentClassNames()}>
        { this.props.children}
      </Col>
    )
  }
}

export default Column
